import {Button} from "@/components/button/Button.tsx";
import styles from "./EmptyEventCard.module.scss";

export interface EmptyEventCardProps {
  message: string;
  ctaLabel?: string;
  onCtaClick?: () => void;
}

export const EmptyEventCard = ({message, ctaLabel, onCtaClick}: EmptyEventCardProps) => (
  <div className={styles.emptyEventCard}>
    <p className={styles.message}>{message}</p>
    {ctaLabel && onCtaClick && (
      <Button variant="secondary" size="small" onClick={onCtaClick}>
        {ctaLabel}
      </Button>
    )}
  </div>
);
